import type { ExhibitionFragment } from '$gen/graphql';
import gql from 'graphql-tag';

export const postTeaser = gql`
    fragment postTeaser on posts_default_Entry {
        id
        __typename
        title
        uri
        dateCreated
        postCategory {
            __typename
            title
            slug
        }
        date: postDate @formatDateTime(format: "d.m.y")
        keyImage @transform(width: 1440, height: 1920) {
            ... on assets_Asset {
                id
                __typename
                url
                width
                height
                srcset(sizes: ["1000"])
                description
            }
        }
        timestamp: postDate @formatDateTime(format: "YmdHis")
    }
`;

export const submissionTeaser = gql`
    fragment submissionTeaser on exhibition_Submission {
        __typename
        id
        title
        dateCreated
        status
        postCategory {
            __typename
            title
            slug
        }
        date: exhibitionOpening @formatDateTime(format: "d.m.y")
        keyImage @transform(width: 1440, height: 1920) {
            ... on submissions_Asset {
                id
                __typename
                url
                width
                height
                srcset(sizes: ["1000"])
            }
        }
        timestamp: dateCreated @formatDateTime(format: "YmdHis")
    }
`;

/** Mini teaser fragments for "Read More Posts" at bottom of a page" */
export const postTeaserMini = gql`
    fragment postTeaserMini on posts_default_Entry {
        id
        __typename
        title
        uri
        dateCreated
        keyImage @transform(width: 500) {
            ... on assets_Asset {
                id
                title
                __typename
                url
                width
                height
                srcset(sizes: ["50w", "100w", "150w", "300w", "600w"])
                description
            }
        }
        timestamp: postDate @formatDateTime(format: "YmdHis")
    }
`;

export const exhibitionTeaserMini = gql`
    fragment exhibitionTeaserMini on exhibition_Submission {
        __typename
        id
        title
        dateCreated
        status
        keyImage @transform(width: 500) {
            ... on submissions_Asset {
                id
                title
                __typename
                url
                width
                height
                srcset(sizes: ["50w", "100w", "150w", "300w", "600w"])
            }
        }
        timestamp: dateCreated @formatDateTime(format: "YmdHis")
    }
`;

export const exhibition = gql`
    fragment exhibition on exhibition_Submission {
        __typename
        id
        title
        exhibitionTitle
        exhibitionEnd
        exhibitionOpening
        curator
        artistsName
        locationName
        linkToVideo
        linkToLocation
        photographer
        socialMediaInfo
        status
        subheadline
        text
        textAuthor
        topColor {
            ... on colors_Category {
                __typename
                color
            }
        }
        bottomColor {
            ... on colors_Category {
                __typename
                color
            }
        }
        images {
            __typename
            rows {
                __typename
                caption
                image {
                    ... on submissions_Asset {
                        __typename
                        id
                        width
                        url
                        title
                        srcset(sizes: "1920")
                        height
                    }
                }
            }
        }
        keyImage {
            ... on submissions_Asset {
                id
                width
                url
                title
                srcset(sizes: "1920")
                height
            }
        }
        ...seoExhibition
    }
`;

export const isExhibition = (item): item is ExhibitionFragment => {
    return (item as ExhibitionFragment).__typename === 'exhibition_Submission';
};
